export const RU = 'ru';
export const KZ = 'kz';
export const languageNames = {
  ru: 'Русский',
  kz: 'Қазақ',
  en: 'English',
  ar: 'العربية',
};
